import { Realty } from '@ambita/ambita-components-core';
import { ApiOwnership } from '../../../typings/Owner';

function transformCadastreOwnerships(cadastreOwnershipData: Realty.ApiResponse) {
  if (cadastreOwnershipData.items && cadastreOwnershipData.items.length > 0) {
    const cadastreOwnerships: ApiOwnership[] = cadastreOwnershipData.items;

    return cadastreOwnerships.map((cadastreOwnership: ApiOwnership) => {
      const retObject: any = {
        ...cadastreOwnership.owningPerson
      };
      if (cadastreOwnership.cadastreLevel) {
        retObject.cadastreLevel = cadastreOwnership.cadastreLevel.text;
      }
      if (cadastreOwnership.fraction) {
        retObject.fraction =
          `${cadastreOwnership.fraction.numerator} / ${cadastreOwnership.fraction.denominator}`;
      }

      return retObject;
    });
  }
}

export default transformCadastreOwnerships;
